import { configureStore } from "@reduxjs/toolkit";
import dataSlice from "./data-slice";
import dataReducer from "./data-slice";
import donationReducer from './form-donation-slice';


// because dataReducer is already a reducer, we dont need to put slice.reducer
const store = configureStore({
    reducer: {
        datareducer:dataReducer,
        donationReducer:donationReducer
    }
});

// EXAMPle if you need to have multiple reducers from diffrent slices
// const store = configureStore({
//     reducer: {
//         counter: counterSlice,
//         favorite: favoriteSlice
//     }
// });




export default store;













//VERSION 1

// import { createSlice, configureStore } from "@reduxjs/toolkit";
// import data from '../JSONs/data.json'

// const initialState = { pages:data.page, description:data.description, fetchRequest:data.fetchRequest,currentPage:data.page.page1 };


// const DataSlice = createSlice({
//     name:'tabclixData',
//     initialState: initialState,
//     reducers: {
//         addDataintoStore(state, action) {
//             state.pages = [...state.pages, action.payload] ;
//         },
//         setCurrentState(state, action) {
//                 state.currentPage = state.pages[action.payload]
//                 // state.currentPage = action.payload;
//             }
//     }
// })

// const store = configureStore({
//     reducer: DataSlice.reducer
// });

// //To get hold of  unique action identifiers,
// //we can use the counterSlice and access .actions = object full of keys that match the reducers name in the reducer area
// export const tabclixActions = DataSlice.actions;

// export default store;
